// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper_f6e6b"};